import { Button } from '@/shared/components';
import type { ExchangeQuickSelectItem } from '../model';

type Props = {
  asset: ExchangeQuickSelectItem;
  onClick: () => void;
};

const ExchangeQuickSelectButton = ({ asset, onClick }: Props) => {
  return (
    <Button
      variant="outline"
      type="button"
      onClick={onClick}
      className="flex items-center gap-[0.6rem] ps-[0.4rem] py-[0.4rem] pe-[1rem] rounded-[1.6rem] border-none shadow-smooth">
      {asset.icon && (
        <img src={asset.icon} alt={asset.code} className="w-[2rem] h-[2rem]" />
      )}
      <span className="headline4">{asset.code}</span>
    </Button>
  );
};

export default ExchangeQuickSelectButton;
